import * as stylex from "@stylexjs/stylex";
import { colors, fonts, spacing } from "@softmax/design-system/tokens.stylex";
import type { MouseEventHandler, ReactElement } from "react";
import { ExternalMark, externalLinkProps } from "../external-mark";
import type {
  SiteNavigationLink,
  SiteNavigationLinkProps,
} from "./site-navigation-types";

export function SiteNavigationDoor({
  item,
  mobile,
  renderLink,
  onNavigate,
}: {
  readonly item: SiteNavigationLink;
  readonly mobile: boolean;
  readonly renderLink: (props: SiteNavigationLinkProps) => ReactElement;
  readonly onNavigate: MouseEventHandler<HTMLAnchorElement>;
}) {
  return renderLink({
    href: item.href,
    ...(item.external ? externalLinkProps : {}),
    onClick: mobile ? onNavigate : undefined,
    ...stylex.props(mobile ? styles.drawerRow : styles.door),
    children: (
      <span>
        {item.label}
        {item.external && <ExternalMark />}
      </span>
    ),
  });
}

const styles = stylex.create({
  door: {
    display: "flex",
    alignItems: "center",
    gap: spacing.space4,
    paddingBlock: spacing.space8,
    color: { default: colors.secondary, ":hover": colors.foreground },
    fontSize: 14,
    lineHeight: "18px",
    letterSpacing: "0.01em",
    textDecoration: "none",
  },
  drawerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBlock: 18,
    paddingLeft: spacing.space12,
    paddingRight: spacing.space12,
    width: "100%",
    boxSizing: "border-box",
    color: colors.foreground,
    fontFamily: fonts.mono,
    fontSize: 20,
    lineHeight: "26px",
    letterSpacing: "0.01em",
    cursor: "pointer",
    textDecoration: "none",
    listStyle: "none",
  },
});
